import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { type ClientPackageDto, updateClientPackage } from '../../generated/client';
import { queryKeys } from '../../query-keys';
import { useClientPackages } from '../queries';

export const useUpdateClientPackage = (): UseMutationResult<ClientPackageDto, AxiosError, Partial<ClientPackageDto>> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { data: client } = useClient();
    const { draftPackage } = useClientPackages();

    return useMutation({
        mutationFn: (payload) => updateClientPackage({ body: { ...draftPackage!, ...payload }, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.clientPackagesForClient(client?.id) });
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
